import { RRule } from 'rrule';
import { View } from '@shared/components/View';
import { Dropdown, DropdownButton, DropdownListItem } from '@shared/components/dropdown';
import { MBTextInput } from '@shared/components/textInput';
import { MBTextBody1, MBTextBody1Bold } from '@shared/components/typography';
import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext/BatchContext';
import { Colors, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { MonthOptions } from './MonthOptions';
import { WeekOptions } from './WeekOptions';
import { YearOptions } from './YearOptions';
import { useCustomBatch } from './hooks/useCustomBatch';

export function CustomBatchDesktop({
  rruleOptions,
  setRruleOptions,
  setUserIsEditing,
}: Pick<Batch, 'rruleOptions' | 'setRruleOptions' | 'setUserIsEditing'>) {
  const { frequencyLabel, interval, freqOptions, handleIntervalChange } = useCustomBatch({
    rruleOptions,
    setRruleOptions,
    setUserIsEditing,
  });

  return (
    <View paddingHorizontal={2}>
      <View
        row
        centerVertically
        style={{
          width: '100%',
          justifyContent: 'flex-start',
        }}
        marginVertical={1.5}
      >
        <View marginRight={1.5}>
          <MBTextBody1Bold>
            {i18n('workflowTemplate.component.dateAndRepeat.everyDotDotDot')}
          </MBTextBody1Bold>
        </View>
        <MBTextInput
          value={String(interval ?? '')}
          onChangeText={handleIntervalChange}
          style={{ width: grid(5.5), borderColor: Colors.v2.gray10, marginRight: grid(1.5) }}
        />
        <Dropdown
          button={({ onClick, isOpen }) => (
            <DropdownButton onClick={onClick} open={isOpen} style={{ flexGrow: 1 }}>
              {frequencyLabel}
            </DropdownButton>
          )}
          closeOnSelect
        >
          {freqOptions.map(option => (
            <DropdownListItem key={option.title} onPress={option.onPress}>
              <MBTextBody1 color={Colors.v2.purple}>{option.title}</MBTextBody1>
            </DropdownListItem>
          ))}
        </Dropdown>
      </View>
      {rruleOptions?.freq === RRule.WEEKLY && (
        <WeekOptions rruleOptions={rruleOptions} setRruleOptions={setRruleOptions} />
      )}
      {rruleOptions?.freq === RRule.MONTHLY && (
        <MonthOptions rruleOptions={rruleOptions} setRruleOptions={setRruleOptions} />
      )}
      {rruleOptions?.freq === RRule.YEARLY && (
        <YearOptions rruleOptions={rruleOptions} setRruleOptions={setRruleOptions} />
      )}
    </View>
  );
}
